import { AdLogo } from 'core/adLogo/AdLogo';
import { BidPriceSetting } from 'core/channelGroup/ChannelGroup';
import { Pagination } from 'core/pagination/Pagination';
export enum AgencyStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

// 列表狀態篩選用值，對應後端查詢參數 status，預設 active
export enum AgencyStatusFilter {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  ALL = 'all'
}

export type Agency = {
  readonly id: number;
  readonly name: string;
  readonly currency: string;
  readonly timeZone: string;
  readonly addOnFeatures: any;
  readonly isOEMAgency: boolean;
  readonly loginTitle: string | null;
  readonly loginDomain: string | null;
  readonly status: AgencyStatus;
  readonly detail: AgencyDetail;
  readonly rebate: AgencyRebate;
};

export type AgencyWithPagination = {
  pagination: Pagination;
  agencies: Agency[];
};

export type AgencyDetail = {
  readonly addonFeatures: any;
  id?: number;
  addonProps: AddonProps;
  bidPriceBase: any;
  oem: boolean;
  companyId?: number;
  companyName: string;
  language: Language;
  currency: Currency;
  timeZone: TimeZone;
  taxPercent: number;
  comComment: string;
  targetBudgetMinimum?: number;
  campaignBudgetMinimum?: number;
  priority: number;
  limitPublisherCountry: Array<
    { label: string; value: string } | Record<string, never>
  >;
  limitPublisher: Array<number>;
  limitAdx: Array<SelectOptions>;
  defaultCountryOp: string;
  agcDataPercent: number;
  agcPercent: number;
  agencyId?: number;
  defaultCountry: Array<
    { label: string; value: string } | Record<string, never>
  >;
  defaultSpace: Array<{ name: string; value: string } | Record<string, never>>;
  defaultSpaceOp: string;
  logoUrl?: string;
  interstitial: number;
  limitAdxOp: string;
  noLimitSelfBuyStatus: boolean;
  segmentCountry: Array<SelectOptions>;
  segmentLabel: Array<SelectOptions>;
  selfBuy: boolean;
  sysDataPercent: number;
  sysPercent: number;
  sysPercentIn: number;
  sysPercentOut: number;
  adLogo: AdLogo;
  logoData?: {
    url?: string;
    file?: any;
  };
  adDeclaration?: FileFieldData | EmptyFileFieldData;
};

export type AddonProps = {
  creditLimit: number;
  fixedExchangeRate: number | null;
  maxOrderProfit: number;
  orderBudgetMaximum: number;
  channelMargin: { [channelId: string]: number };
  expressPass: {
    [channelId: string]: {
      adDeclarationUrl: string;
    };
  };
  campaignBidPrice?: (
    | {
        type: string;
        adTypeId?: undefined;
        autoBidCap: BidPriceSetting;
        bidFloor: BidPriceSetting;
      }
    | {
        type: string;
        adTypeId?: number;
        autoBidCap: BidPriceSetting;
        bidFloor: BidPriceSetting;
      }
  )[];
};

export enum Currency {
  NTD = 'NTD',
  USD = 'USD',
  MYR = 'MYR',
  JPY = 'JPY',
  VND = 'VND',
  EUR = 'EUR',
  IDR = 'IDR'
}

export enum Language {
  ZHTW = 'zh_TW',
  ENUS = 'en_US',
  JAJP = 'ja_JP'
}

export enum TimeZone {
  TOKYO = '+09:00',
  TAIPEI = '+08:00',
  HOCHIMINH = '+07:00' // combine with JAKARTA
}

export type AgencyRebate = {
  currentRate: number;
  effectDate?: string;
  futureRate?: number;
};

export type UpdateAgencySelfRequest = {
  companyId?: number;
  addonProps: AddonProps;
  agcPercent: number;
  adLogo: AdLogo;
  logoData: {
    url?: string;
    file?: any;
  };
  adDeclaration: FileFieldData | EmptyFileFieldData;
};
